import { createAction } from '@reduxjs/toolkit';

import { useActionObservableCallback } from '@perpay-web/hooks/useActionObservableCallback';
import { useSteps } from '@perpay-web/hooks/useSteps';
import { hookAction$ } from '@perpay-web/services/singletons';
import { createContextProvider } from '@perpay-web/utils/componentUtils';

export const PAYCHEX_REVIEW_STEP = 'review';
export const PAYCHEX_ERROR_STEP = 'error';
export const PAYCHEX_INSTRUCTIONS_STEP = 'instructions';

const PAYCHEX_STEPS = [
    PAYCHEX_REVIEW_STEP,
    PAYCHEX_ERROR_STEP,
    PAYCHEX_INSTRUCTIONS_STEP,
];

export const paychexStepsSetStep = createAction('PAYCHEX_STEPS::SET_STEP');

const usePaychexSteps = () => {
    const hook = useSteps(PAYCHEX_STEPS);

    return hook;
};

const providerFactory = (Context) => {
    const Provider = ({ children }) => {
        const hook = usePaychexSteps();

        useActionObservableCallback(
            hookAction$,
            paychexStepsSetStep().type,
            (step) => hook.setStep(step),
        );

        return <Context.Provider value={hook}>{children}</Context.Provider>;
    };

    return Provider;
};

export const [PaychexStepsProvider, usePaychexStepsContext] =
    createContextProvider(providerFactory);
